<template>
  <a class="work__link" :href="work.link">
      <img class="work__image" v-if="work._embedded['wp:featuredmedia'] && work._embedded['wp:featuredmedia'][0]" :src="work._embedded['wp:featuredmedia'][0].source_url">
      <div class="work-overlay"></div>
      <img v-if="work.award === true" src="https://wisdom-site-wisdom-com-au.s3.ap-southeast-2.amazonaws.com/uploads/2020/09/award-white.svg" alt="award" class="work__award">
      <div class="work-content">
        <h2 class="work__type" v-html="work.title.rendered"></h2>
        <h3 class="work__client">{{ getClient(work) }}</h3>
      </div>
  </a>
</template>

<script>
// import axios from 'axios';
// import Clients from './Clients';

export default {
  name: 'Work',
  data() {
    return {
      // works: [],
      // categories: [],
      // clients: [],
      // currentCategory: '',
      // workCount: 0,
      // showFirstLoad: 5,
      // filterAward: false,
      // currentClient: ''
    }
  },
  components: {
    // Clients
  },
  props: [
      'work'
  ],
  methods: {
    // categoryClickHandler(category) {
    //   this.currentCategory = category
    //   this.workCount = this.showFirstLoad
    //   this.filterAward = false
    // },
    getClient(work) {
      let client = []
      if(work._embedded['wp:term'] && work._embedded['wp:term'].length > 0) {
        work._embedded['wp:term'].forEach(terms => {
          terms.forEach((term) => {
            if(term.taxonomy === 'clients') {
              client = term.name
            }
          })
        })
      }
      return client
    },
  },
  mounted() {
    // axios.get("https://fresh.wisdom.com.au/wp-json/wp/v2/work?_embed&per_page=2001")
    // .then(response => {
    //   this.works = response.data
    // })
    // axios.get("https://fresh.wisdom.com.au/wp-json/wp/v2/expertise")
    // .then(response => {
    //   this.categories = response.data
    // })
    // axios.get("https://fresh.wisdom.com.au/wp-json/wp/v2/clients?per_page=2000")
    // .then(response => {
    //   this.clients = response.data
    // })
    // this.workCount = this.showFirstLoad

    // window.addEventListener('wisdom-posts-client-localstorage-changed', (event) => {
    //   console.log(event.detail.client)
    //   if(event.detail.client.count === 1) {
    //       let filteredWork = this.works.filter(work => {
    //       let match = false
    //         if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
    //         work._embedded['wp:term'].forEach(term => {
    //           term.forEach(t => {
    //             if(t.id === event.detail.client.id) {
    //               match = true
    //           }
    //           })
    //         })
    //         return match
    //     })
    //     window.location.href = filteredWork[0].link
    //   }
    //   this.currentClient = event.detail.client;
    //   let works = document.getElementById("works");
    //   works.scrollIntoView();
    // });

    // window.addEventListener('update-expertise', (event) => {
    //   this.categoryClickHandler(event.detail.category)
    // });
    
    // window.addEventListener('filter-award', (event) => {
    //   this.filterAward = event.detail.award
    // });

    
    // let self = this
    // window.onhashchange = function () {
    //   if (location.hash === '#latest') {
    //     console.log('latest')
    //     self.currentCategory = ''
    //     self.filterAward = false
    //   }
    // };




    // window.addEventListener('load-more-work', () => {
    //     this.workCount += 6;
    //     if(this.showLoadMore === false) {
    //       window.dispatchEvent(new CustomEvent('show-load-more-work', {
    //         detail: {
    //           hide: 'true'
    //         }
    //       }));
    //     }
    // });

  },
  computed: {
    // showLoadMore() {
    //   return this.workCount < this.filteredWorks.length && this.filteredWorks.length > 5
    // },
    // filteredWorks() {
    //   let self = this
    //   if(this.filterAward === true) {
    //     return this.works.filter(work => {
    //       return work.award === true
    //     })
    //   }
    //   if(this.currentClient != '') {
    //     return this.works.filter(work => {
    //       let match = false
    //       if(self.currentClient != '') {
    //         if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
    //         work._embedded['wp:term'].forEach(term => {
    //           term.forEach(t => {
    //             if(t.id === this.currentClient.id) {
    //               match = true
    //           }
    //           })
    //         })
    //         return match
    //       }
    //       else {
    //         return true
    //       }
    //     })

    //   }
    //   return this.works.filter(work => {
    //     let match = false
    //     if(self.currentCategory != '') {
    //       if(!work._embedded['wp:term'] || work._embedded['wp:term'].length == 0) return false;
    //       work._embedded['wp:term'].forEach(term => {
    //         term.forEach(t => {
    //           if(t.id === this.currentCategory.id) {
    //             match = true
    //         }
    //         })
    //       })
    //       return match
    //     }
    //     else {
    //       return true
    //     }
    //   })
    // },
    // filteredWorksPagination() {
    //   return this.filteredWorks.slice(0,this.workCount)
    // },
    // industries() {
    //   let industriesArray = [];
    //   this.clients.forEach(client => {
    //     if(!industriesArray.includes(client.industry)) {
    //       industriesArray.push(client.industry)
    //     }
    //   })
    //   return industriesArray;

    // }
  }
}
</script>

<style scoped>
.works span {
  display: flex;
  flex-wrap: wrap;
}
.work {
  text-align: left;
  flex-basis: 33.33%;
  position: relative;
  height: 450px;
  font-family: "Circular std book", Sans-serif;
}
.work:hover .work-overlay,
.work:hover .work-content {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.work-content {
  opacity: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  text-align: right;
  padding: 2.1875em;
  color: white;
}
.work__award {
  width: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.work-overlay {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
}
.work .work__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.work .work__type {
  font-size: 35px;
  margin-top: 0;
  margin-bottom: 0.25em;
  font-family: inherit;
}
.work .work__client {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 0;
  font-family: inherit;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
